import el from 'element-ui/lib/locale/lang/zh-CN';

/* eslint-disable */
export default {
  app: {
    hi: ' 您好',
    name: 'Okubuy',
    login: '登入',
    logout: '登出',
    register: '注册',
    reset_password: '重置密码',
    default: '默认',
    create_account: '建立账号',
    delete: '删除',
    edit: '编辑',
    tips: '提示',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    view_more: '查看更多',
    view: '查看订单',
    share: '分享',
    submit: '提交',
    no_limit: '不限',
    file_only_accept_jpg_png: '上傳文件只能是 jpg、png格式',
    file_size_only: '上傳圖片大小不能超過{size}',
    search: '搜索',
    reset: '重置',
    select_all: '全选',
    inputMoreThanWords: '输入不能少于{0}个字符',
    please_login: '请先登录账号',
    submit_err: '提交失败',
    delete_err: '删除失败',
    search_bar_placeholder: '输入商品或品牌名称，搜索全场商品',
    loading_captcha: '正在加载验证码...',
    loading: '正在加载中...',
    currency: '货币',
    yes: '是',
    none: '否',
  },
  topbar: {
    faq: '常见问题',
    guide: '新手指南',
    exchange_rate: '参考汇率',
  },
  nav: {
    home: '首页',
    shop: '商店',
    forwarding: '转送',
    more_classify: '查看更多分类>>',
    proxy_request: '请求代购',
    product_promotion: '商品推荐',
    straight: '直购',
    proxy_buy: '代购',
    new_product: '最新商品',
    off_price_product: '特价商品',
    hot_sales_product: '热销商品',
    recommend_product: '推荐商品',
    free_postage_product: '包邮商品',
    all_product: '所有商品',
  },
  faq: {
    most_popular_questions: '最热门问题',
    account_registration: '会员註冊',
    making_purchase: '购买商品',
    package: '包裹入仓与发送',
    other_questions: '其它',
    answer_your_questions: '此FAQ是否有解答到您的疑问？',
    thankyou_for_your_feedback: '提交成功！非常感谢您的反馈，我们会继续努力做到更好！',
    ask_us: '还沒有找到答案？问我们。',
    we_respond_within_2days: '我们通常会在2個工作日内回复。最热门的问題将出现在此页面上。',
    subject: '主题',
    your_name: '名称',
    cellphone: '电话号码',
    email: '邮箱',
    category: '分类',
    question: '问题',
    placeholder: {
      name: '填写您的名称',
      email: '填写您的邮箱地址',
      category: '请选择问题类型',
      question: '请填写您的问题',
      subject: '请填写您的主题',
      cellphone: '请填写你的电话号码',
    },
    rules: {
      name: '名称不能为空',
      email: '邮箱地址不能为空',
      correct_email: '请填写正确的邮箱地址',
      category: '请选择问题类型',
      question: '问题不能为空',
      question_len: '问题至少输入3个字符',
      subject: '主题不能为空',
    },
  },
  shop_names: {
    rakuten: 'Rakuten',
    yahoo_jp: 'YAHOO!JAPAN',
    amazon_jp: 'Amazon JP',
  },
  login: {
    page_title: '登入或建立账号',
    registered: '已注册？',
    login_tips: '如果您已有账号，请登入',
    mobile_authenticated: '手机号码已注册？',
    mobile_tips: '请输入手机号码，以获取短信验证码登入',
    remember_me: '记住我',
    forgot_password: '忘记密码？',
    placeholder: {
      account: '请输入登录账号或邮箱',
      password: '请输入登录密码',
      mobile: '请输入已经注册的手机号码',
      shipbaoAccount: '请输入SHIPBAO账号',
      shipbaoPassword: '请输入SHIPBAO密码',
    },
    rules_message: {
      account_required: '请输入登录账号或邮箱',
      password_required: '请输入登录密码',
      mobile_required: '请输入手机号码',
      mobile_error: '请输入正确的手机号码',
      captcha_required: '请输入短信验证码',
    },
    accountLogin: '账号登录',
    smsLogin: '短信验证码登录',
    thridPartyLogin: '第三方登录',
    get_sms_captcha: '获取验证码',
    sms_captcha: '短信验证码',
    resend: '重新发送',
    register: '注册会员',
    un_regisered: '还没注册?',
    register_tips: '注册免费而快捷!',
    registered_infos: [
      '能够快速结账',
      '能够登录多个收货地址',
      '能够查看追踪订单状态',
    ],
    login_fail: '登录失败',
    shipbaoLoginTerm: '我同意使用<a href="https://shipbao.com/">SHIPBAO</a>账号登录并以此创建OKUBUY账号',
  },
  reset: {
    send: '发送',
    reset: '重置密码',
    email: '邮箱',
    password: '密码',
    confirm_password: '确认密码',
  },
  register: {
    page_title: '创建账户',
    register_tips: '输入下列信息来创建您的账户',
    accepted: '同意并继续',
    reject: '拒绝',
    read_and_accepted: '我已阅读并同意',
    labels: {
      email: '电子邮箱',
      phone: '电话号码',
      password: '密码',
      password_confirmation: '确认密码',
      referral_code: '介绍人会员号码',
    },
    placeholder: {
      email: '请输入电邮地址',
      phone: '请输入您的电话号码',
      password: '设置您的密码，长度必须介乎 6 至 20 个字符之间',
      password_confirmation: '请再次确认您的密码',
      referral_code: '填写您的介绍人会员号码，选填项',
    },
    rules_message: {
      email_type: '请输入正确的电邮',
      email_required: '请填写电邮地址',
      phone_required: '请填写您的电话号码',
      password_required: '请输入登录密码',
      password_length: '长度必须介乎{min}至{max}个字符之间',
      password_confirmation_required: '请再次确认密码',
      password_not_comfirmed: '两次输入的密码不一致',
    },
  },
  activation: {
    thank_you_registered: '感谢您注册{appname}',
    active_your_account: '请激活您的帐号',
    send_mail_tips: '我们已经发送邮件到您的电子邮箱:{email}，请按照邮件指示激活您的帐号',
    resend_link: '如果您没有收到邮件，点击这里重新发送',
    activing: '正在激活您的账户...',
    activation_successed: '您的账户已激活，祝购物愉快！ ！',
    bind_successed: '绑定成功，祝购物愉快！！',
    activation_failed: '激活失败',
  },
  user: {
    user_center: '会员中心',
    my_account: '我的账户',
    my_orders: '我的订单',
    product_view_history: '我的足迹',
    lately_history: '最近足迹',
    add_recommend: '加购优惠',
    lately_orders: '最近订单',
    not_lately_orders: '最近没有新的订单',
    not_lately_history: '最近没有新的足迹',
    not_lately_wishlist: '没有收藏的商品',
    not_lately_ship: '没有添加收货地址',
    history_err: '获取我的足迹失败',
    information: '个人信息',
    wish_list: '我的收藏',
    shipping_address: '收货地址',
    proxy_list: '代购请求',
    registration_in: '注册于',
    last_login_time: '上次登录时间',
    coupon: '我的优惠券',
    integral: '我的积分',
    generalize: '推广等级',
    coupons: '优惠券',
    promotion: '推广赚佣金',
    member: '会员等级',
    balance: '我的余额',
    logout: '登出',
    order_detail: '订单详情',
    orders_err: '获取订单失败',
    go_to_login: '去登入',
    added_to_wishlist: '已加入收藏夹',
    removed_wishlist: '已移出收藏夹',
    success: '修改成功',
    screen: '分类筛选',
    upload_img_err: '上传头像图片大小不能超过 2MB!',
    type: '类型',
    content: '內容',
    time_limit: '期限',
    immediate_use: '立即使用',
    be_usable: '可使用',
    used: '已使用',
    expired: '已过期',
    no_coupons: '没有可使用的优惠券'
  },
  guide: {
    registered_members: '注册会员',
    buy: '如何购买',
    payment: '付款条件',
    charge: '代购商品收费',
    pay_attention: '注释和条款',
    first: {
      one: '1：注册',
      two: '请点击主页右上角的「Register」(会员注册）链接进入会员注册网页。点选注册。',
      three: '2：设定用户ID、密码和填写电邮地址',
      four: '用户ID可以设定为电邮地址或电话号码，并填写一个有效的电邮地址以接收确认邮件。',
      five: '设定好用户ID，密码和电邮地址后，点击「Submit」按钮提交会员注册申请。',
      six: '3：确认邮件',
      seven: '完成注册后，请到您的注册邮箱打开OKUBUY寄给您的邮件并“确认连结”进行帐号确认。\n' +
        '当完成电邮地址确认后，会员帐号的登记手续就完成，可以使用这个帐号来购物。如果没有收到邮件请查询垃圾信箱。',
    },
    second: {
      one: 'OKUBUY直购',
      two: 'OKUBUY直购区刊登的商品皆为现货商品，购买后可以快速寄出。付款完毕后如果商品已经在货仓则于次日出货。',
      three: '如果您有其他代购商品想合并寄出，可以在选择寄送方式时点选「送到我的仓库」。当代购商品抵达时，再使用合并包裹功能一起出货。',
      four: '由于商品在付款完成后会直接进入购买流程，除非商品缺货或是价格有波动，否则无法取消订单，购买前请先确认订购之商品无误。',
      five: '搜寻到欲购买的商品后，点击「加入购物车」的按钮。',
      six: '确认商品内容与合计金额。如资料无误，点击「结账」按钮。',
      seven: '确认好帐单地址后，请点击「继续」按钮。',
      eight: '选择配送方式后，请点击继续按钮。',
      nine: '选择支付方式与确认订单内容后，请点击「结账」按钮完成订购。',
      ten: '完成订购后，您可时随时在「我的帐号」内的订单页面中查阅有关订单的内容。在成功购买您订购的商品后，OKUBUY将会发送电子邮件通知您。',
      eleven: 'Amazon或Ratuten代购',
      twelve: '只要在OKUBUY的首页点选代购 —「Amazon亚马逊」或「Ratuten乐天」，您在Amazon或Ratuten的购物篮商品会直接进入OKUBUY代购篮。',
      thirteen: '其他网站代购',
      fourteen: 'OKUBUY可以代购一些只可在品牌官网或其他商店才能购买的商品。请填写「代购」表格，待订单确认后付款。',
      fifteen: '由于商品在付款完成后会直接进入购买流程，除非商品缺货或是价格有波动，否则无法取消订单，购买前请先确认订购之商品无误。',
    },
    third: {
      one: '付款方式',
      two: '接受Paypal, Payme, 微信，支付宝及银行入账付款。',
    },
    fifth: {
      one: '关于商品',
      two: '1. 货品包装单边（长，阔或高）任何一边不能超过60cm，如果超过60cm必须按照体积重量收费。',
      three: '2. 货品包装总长（长加阔加高三边总长）不能超过120cm，如果超过120cm必须按照体积重量收费。',
      four: '配送方式',
      five: '货到香港后，会以E-MAIL通知客户到自提点取件（免费）或送货上门（需额外收费）。',
    },
    fourth: {
      Calculation: '代购商品收费计算',
      country: ['', '日本', '美国', '澳洲', '英法德', '韩国', '泰国', '台湾'],
      fee: ['手续费', '50', '50', '50', '50', '50', '50', '50'],
      internation: ['国际运费（每磅）', '25', '25', '25', '30', '25', '25', '25'],
      local: ['当地运费', '按代购网站/商店收费标准，实报实销收费。'],
      price: ['商品价格', '商品价钱＆当日汇率'],
      localPrice: ['支付平台費用', '5%', '5%', '5%', '5%', '5%', '5%', '5%'],
    }
  },
  user_info: {
    personal: '修改资料',
    avatar_image: '上传头像',
    login_name: '登录名',
    update_password: '修改密码',
    old_password: '原始密码',
    new_password: '新密码',
    confirm_password: '确认密码',
    keep: '保存',
    actual_name: '真实姓名',
    can_only_be_changed_once: '登录名只能修改一次',
    gender: '性别',
    male: '男',
    female: '女',
    secrecy: '未知',
    birthday: '生日',
    choose_birthday: '选择日期',
    phone_number: '电话号码',
    change_password: '密码已修改成功',
  },
  order: {
    id: '订单号',
    type: '订单类型',
    quantity: '数量',
    amount: '金额',
    status: '订单状态',
    order_date: '下单日期',
    subtotal: '小计',
    name: '商品名称',
    price: '价格',
    size: '尺码',
    color: '颜色',
    shipping: '运费',
    tax: '税',
    sale_tax: '消费税',
    import_tax: '进口税',
    total: '统计',
    total_tax: '含税',
    payment: '立即付款',
    shipping_fee: '运费',
    local_shipping_fee: '本地运费',
    overseas_shipping_fee: '海外运费',
    handling_fee: '手续费',
    contains_shipping_fee: '含运费',
    order_detail: '下单详情',
    created_at: '下单时间',
    cancel_order: '取消订单',
    filter_all: '所有订单',
    filter_unpaid: '待付款',
    filter_delivered: '待发货',
    filter_shipping: '待收货',
    filter_uncomment: '待评价',
    filter_closed: '已关闭',
    filter_completed: '已完成',
    filter_wait_for_pickup: '待自提',
    filter_last_3_months: '最近3个月订单',
    filter_last_6_months: '最近半年订单',
    filter_input_placeholder: '搜索订单号或者商品名',
    payment_method: '付款方式',
    payment_status: '付款状态',
    payment_timeout_tips: '请在以下时间前付款，超时订单自动关闭',
    wait_for_ship: '等待仓库发货',
    step1: '提交订单',
    step2: '付款成功',
    step3: '商品发货',
    step4: '订单完成',
    step5: '评价',
    step6: '待付款',
    shipping_info: '收货信息',
    shipping_method: '配送方式',
    payment_info: '付款信息',
    products: '订单商品',
    total_product: '全部商品',
    total_price: '总价钱',
    order_closed: '超时订单将自动关闭: ',
    successful_payment: '付款成功，等待卖家发货',
    shipped: '商家已发货，请注意收货',
    comment: '买家已收货，您可以对商品进行评价',
    suborder_splited_payment_tips: '该订单属于{main_order}的子订单，请前往主订单页面进行付款，给您带来的不便敬请谅解.',
    view_main_order: '查看主订单',
    tracking_parcel: '追踪包裹',
    commodity: '商品详情',
    detail: '详情',
    operating: '操作',
    comment_btn: '评价',
    del_order: '取消订单',
    buy_again: '再次购买',
    product_add_car: '是否把订单商品重新加入购物车',
    change_payment_method: '更改支付方式',
    view_logistics: '查看物流',
    to_pay: '去支付'
  },
  shipping_fee: {
    free_pick_up_price: '满{price}免自提费',
    pick_up_price: '不满加收自提费{price}',
    free_postage_condition: '满{price}免快递费',
    desc_1: '不满加收运费{price}',
    desc_2: '首重{first_weight}{weight_unit} {first_weight_price}，续重每{add_weight}{weight_unit} {add_weight_price}',
    additional_fees: '附加费用',
    import_tax: '进口税',
    sale_tax: '消费税',
  },
  wish_list: {
    product_name: '商品名称',
    wish_poduct: '收藏商品',
    wish_add_car: '加入购物车',
    clear_wish_list: '清空收藏列表',
    add_to_wish_list_err: '添加收藏夹失败',
    remote_wish_list_err: '移除收藏夹失败',
    confirm_clear_list: '确定清空列表吗',
  },
  product: {
    none_specification: '沒有规格与包装数据',
    none_comment: '沒有评论',
    none_advisories: '沒有咨询',
    distribution: '配送提醒',
    id: '商品ID',
    product: '商品',
    name: '商品名称',
    product_categories: '商品分类',
    detail: '详细',
    price: '价钱',
    old_price: '原价',
    unit_price: '单价',
    specification: '规格',
    brand: '品牌',
    unit_tax: '税',
    total: '总价',
    quantity: '数量',
    subtotal: '小计',
    product_details: '商品详情',
    upc: '商品编号',
    inventory: '库存',
    availability: '可用性',
    description: '商品详情',
    parameter: '规格与包装',
    reviews: '评论',
    comment_has_number: '评论({0})',
    product_name: '商品名称',
    weight: '重量',
    length: '长度',
    width: '宽度',
    height: '高度',
    specification_and_packaging: '商品图片',
    advisories: '咨询',
    advisories_has_number: '咨询({0})',
    comment_time: '评论时间',
    recovery_time: '回复时间',
    let_us_help_you_to_answer_your_doubts: '提出你的疑惑，让我们来帮你解答',
    to_ask_questions: '提问',
    question: '问',
    answer: '答',
    no_answer: '暂无回答',
    advisory_err: '提问失败',
    input_more_than4_words: '请输入4个字以上',
    product_list: '商品列表',
    all_categories: '所有分类',
    load_more: '加载更多商品',
    load_more_error: '加载商品失败，请稍后再试',
    tax_included: '含税',
    stock_inform: '到货通知',
    more: '更多>>',
    distribution_nonsupport: '不支持配送的国家或地区',
    serve: '服务',
    serve_content: '本商品由',
    shipments: '发货',
    source: '来源地',
    delivery: '配送',
    pickup: '自提费',
    pickups: '订单满{price}免自提费',
    freight: '运费',
    freights: '订单满{price}免运费',
    estimated_time: '预计{time}天送达',
    authentic_guarantee: '正品保证',
    returns: '支持退换货',
    in_stock: '现货发售',
    authentic_guarantee_txt: 'OKUBUY承诺所售商品均为100％正品',
    returns_txt: '该商品售后7天有质量/缺件问题可申请售后，审核通过后即可退换货',
    in_stock_txt: '商品均为现货，正常48小时內发货',
    not_returns: '不支持退换货',
    not_returns_txt: '该商品不支持退换货',
    product_upc: '商品UPC',
    coupon: '优惠券',
    restricted_purchase: '限购',
    hkTo: '香港仓 至 ',
  },
  product_list: {
    shop_categories: '商品分类',
    price_range: '价格范围',
    filter: '过滤',
    filter_by_brand: '按品牌过滤',
    filter_by_source: '按来源地過濾',
    list_page_total: '共{0}个商品',
    sort_by: '排序',
    sort_by_index: '综合',
    price: '价格',
    sort_by_new: '上架时间',
    search_keyword: '搜索关键字',
    brand: '品牌',
    loading_goods: '正在加载更多商品',
    loading_goods_not: '没有更多商品',
  },
  shipping_address: {
    add_address: '添加新地址',
    consignee: '收货人',
    mobile: '移动电话',
    phone: '固话',
    email: '电邮',
    district: '地区',
    zip_code: '邮编',
    address: '地址',
    line1: '详细地址',
    line2: '详细地址2',
    company: '公司',
    additional_information: '结账信息',
    set_default: '默认',
    confirm_delete: '确定要刪除该收貨地址吗？',
    deleted: '收货地址已刪除',
    label: '地址参考名称',
    label_placeholder: '建议填写常用名称',
    reference_name: '参考名称',
    my_home: '家庭',
    apartment: '公寓',
    parents_home: '父母家',
    express_box: '快递柜',
    school: '学校',
    warehouse: '仓库',
    hostel: '旅店',
    consignee_placeholder: '填写收货人姓名',
    zip_code_placeholder: '填写邮政编码',
    email_placeholder: '接收点单物流信息邮件',
    company_placeholder: '填写公司名称',
    mobile_placeholder: '填写移动电话号码',
    area_code: '区号',
    phone_placeholder: '区号-固话号码-分机号',
    select_district: '请选择收货地址地区',
    address_placeholder: '建议您如实填写详细收货地址，例如街道名称，门牌号码，楼层和房间号等信息',
    additional_information_placeholder: '',
    confirm_close_dialog: '收货地址还沒有保存，確定关闭？',
    edit_address: '编辑地址',
    required_field_no_compltet: '帶*号为必填项，请填写完整',
    address_has_been_save: '地址已保存',
    tracking_number: '跟踪号码',
    zipcode: '邮编',
    rules: {
      label_reduired: '请填写地址标签，以方便您的使用',
      consignee_reduired: '请填写收货人姓名',
      zipcode_required: '请填写邮政编码',
      email_reduired: '请填写电子邮箱',
      email: '请填写正确的邮箱地址',
      mobile_reduired: '请填写您的电话号码',
      selectedDistricts_reduired: '请选择收货地址的地区',
      line1_required: '请输入您的收货地址',
    },
  },
  area: {
    China: '中国大陆',
    HongKong: '香港',
    Macau: '澳门',
    TaiWan: '台湾',
    US: '美国',
    France: '法国',
    UK: '英国',
    Germany: '德国',
    Malaysia: '马来西亚',
    Australia: '澳洲',
    NewZealand: '纽西兰',
    Singapore: '新加坡',
    Thailand: '泰国',
    Japan: '日本',
    Korea: '韩国',
    VietNam: '越南',
    Cambodia: '柬埔寨',
  },
  footer: {
    contacts: '咨询',
    contact_us: '联络我们',
    phone: '电话',
    monday_friday: '周一至五',
    customer_service: '客户服务',
    faq: '常见问题',
    delivery: '配送安排',
    payment_method: '付款方法',
    information: '咨询',
    news: '最新消息',
    terms_and_conditions: '条款及条件',
    privacy_policy: '隐私政策',
    about_us: '关于我们',
    my_account: '我的账户',
    contact_us_me: '与我们联系',
    subscription: '订阅',
    show_map: '显示地图地址',
    subscribe: '订阅我们的通讯，以接收早期的折扣优惠，最新消息，销售和宣传信息。',
  },
  article: {
    release_time: '发布时间',
    warehousing_and_delivery: '包裹入仓与发送',
    ask_us: '还沒有找到答案？问我们',
    we_normally_respond: '我们通常会在2个工作日內回复。最常见的问题将出现在此页面上。',
    your_name: '您的名称',
    category: '分类',
    question: '问题',
    placeholder: {
      name: '填写您的名称',
      category: '请选择问题类型',
      question: '写下您的问题',
    },
  },
  home: {
    featured_products: '精选商品',
    sale_products: '特价商品',
    top_sellers: '热销商品',
    new_arrivals: '最新商品',
    recommend_products: '推荐商品',
    popular_brands: '热门品牌',
    shipping: '免费送货',
    shipping_detailed: '所有超过100美元的订单免运费',
    money_back: '退款保证',
    money_back_detailed: '我们会在30天内退货',
    customer_support: '全天候客户支持',
    customer_support_detailed: '友好的全天候客户支持',
    secure_online_payment: '安全在线支付',
    secure_online_payment_detailed: '我们拥有SSL/安全证书',
  },
  cart: {
    add_to_cart: '添加到购物车',
    cart: '购物车',
    view_cart: '查看购物车',
    price: '单价',
    checkout: '结算',
    no_login_tips: '登入后购物车的商品将保存到您的账号中',
    continue_shipping: '继续购物',
    operation: '操作',
    remove: '刪除',
    add_to_wishlist: '收藏商品',
    added_to_wishlist: '已收藏',
    delete_wislist: '已取消收藏',
    defeated_delete_wislist: '取消收藏失败',
    product_has_been_removed: '商品已从购物车中移除',
    product_has_benn_removed_to_wishlist: '商品已经移到收藏夹',
    product_move_to_wishlist_and_remove_cart: '商品移到收藏夾並移除購物車',
    update_to_cart_err: '更新购物车失败',
    empty_cart_tips: '您的购物车沒有商品',
    total_product: '全部商品',
    total_tax: '税总计',
    add_to_cart_err: '加入购物车失败',
    update_cart_err: '更改购物车失败',
    it_is_cheaper: '价钱比之前便宜了',
    it_is_expensive: '价钱比之前贵了',
    remove_err: '移除失败',
    add_to_cart_success: '成功加入购物车',
  },
  redemption_center: {
    name: '自提点',
    district: '地区',
    address: '地址',
    phone: '电话',
    business_hours: '营业时间',
  },
  order_pay: {
    pay_id: 'PAY ID',
    amount: '金额',
    pay_time: '付款时间',
  },
  checkout: {
    product: '商品',
    unit_price: '单价',
    unit_tax: '税',
    sale_tax: '消费税',
    import_tax: '进口税',
    merchandise_news: '商品信息',
    remarks: '输入备注信息',
    quantity: '数量',
    price: '价钱',
    additional_information: '额外信息',
    billing_information: '结算信息',
    shipping_methods: '配送方式',
    self_pick_up: '自提点取件',
    district_only_hk: '暂时只支持配送香港地区',
    courier: '快递',
    self_point_address: '自提点地址',
    shipping_address: '收货地址',
    add_shipping_address: '新增收货地址',
    payment_method: '付款方式',
    audit_order: '审核订单',
    order_created: '已创建订单',
    prev: '上一步',
    next: '下一步',
    back_to_cart: '回到购物车',
    your_cart_is_empty: '您的购物车没有商品',
    free_postage_tips: '提示：订单满{price}免快递费',
    free_pick_up_tips: '提示：订单满{price}免自提费',
    go_to_shopping: '去购物',
    submit_orders: '提交订单',
    area_group_diffent_tips: '根据您的收货地址，系统将自动成收货地使用货币结算',
    picker: '取件人',
    phone: '手机号码',
    logistics_type: '物流类型',
    logistics_type_1: '特快服务',
    logistics_type_2: '专线快递',
    logistics_type_3: '标准服务',
    logistics_fee: '费用',
    logistics_estimated_time: '预计时效',
    consignee_form_validate_error: '请填写正确的取件人信息',
    placeholders: {
      name: '取件人姓名，用于取件时核对',
      phone: '取件密码将会发送到该手机号码，请确定该号码可收取短信',
    },
    rules: {
      picker_required: '请填写取件人姓名',
      phone_required: '请填写取件人的电话，取件密码将会发送到该手机号码',
    },
    checkout_fail: '结账失败',
    get_self_point_address_err: '获取自提点失败',
    get_shipping_address_err: '获取收货地址失败',
    please_select_checkout_item: '请选择要结账的商品',
    order_split_tips: '您订单中的商品在不同的仓库，需要拆分订单分开配送，给您带来的不便敬请谅解。 ',
    please_input_promote_code: '请输入你的优惠代码',
    promote_code_placeholder: '输入优惠代码',
    promo_code: '优惠码',
    Remote_areas: '住宅或偏远地址附加费HKD $20，由司机上门额外收取，如拒付住宅或偏远地址附加费导致派件失败，客户需额外支付二次派送费用',
    none: '不使用',
    day: '天',
  },
  proxy_request: {
    code: '编号',
    contact_phone: '联络电话',
    product_name: '商品名',
    product_url: '商品URL',
    image: '图片',
    price: '参考价格',
    quantity: '数量',
    size: '型号/尺寸',
    color: '颜色',
    remark: '备注',
    created_at: '日期',
    status: '状态',
    click_upload: '点击上传',
    placeholders: {
      contact_phone: '请留下您的联系电话，以便客服确认您的代购商品',
      product_name: '输入您所需要代购的商品名',
      product_url: '输入您需要代购的商品的URL',
      price: '以HKD为货币单位的商品参考价格，实际交易价格以订单为准',
      size: '如果商品页面中含有多款型号/尺寸，请输入你所需要的型号/尺寸',
      color: '如果商品页面中含有多款颜色，请输入你所需要的颜色',
    },
    rules: {
      contact_phone_required: '请留下您的联系电话，以便客服确认您的代购商品',
      product_name_required: '请填写商品名称',
      product_url_required: '请填写购物网站的URL',
      product_url: '请填写正确的URL地址，以http://或https://开头',
      price_required: '请填写商品价格',
      quantity_required: '请填写代购商品数量',
      shipping_method_required: '请选择配送方式',
      redemption_center_id_required: '请选择自取点',
      address_id_required: '请选择收货地址',
      payment_method_required: '请先用paypal付款',
    },
    please_add_shipping_address: '请先添加收货地址',
    not_found: '没有该代购请求',
    updated: '您的代购请求已修改',
    created: '已提交您的代购请求',
    canceled: '您的代购请求已取消',
    reject: '您的代购请求被拒绝',
    reject_reason: '拒绝原因',
    cancel: '取消',
    cancel_tips: '您确定要取消这个代购请求吗？ ',
  },
  rakuten: {
    product_detail: '乐天商品',
    product_info: '商品信息',
    tax_include: '含税',
    view_item_from_rakuten: '阅览乐天页面',
    shop_name: '店铺名称',
    item_code: '商品代码',
    category: '分类',
    tag: '标签',
    review_count: '评价数',
    review_count_text: '{0}个商品评论',
    review_average: '综合评价',
    shipping_tips: '若商品属于违禁品或禁止贩售至海外的商品均有可能无法通关。我们将取消此类商品的订单。敬请见谅。 ',
  },
  yahoo: {
    product_detail: '雅虎商品',
    view_item_from_yahoo: '阅览雅虎页面',
    shop_name: '店铺名称',
    item_code: '商店代码',
    review_count: '评价数',
    review_count_text: '{0}个商品评论',
    review_average: '综合评价',
    category: '分类',
    product_info: '商品信息',
    view_review: '查看评价',
    shipping_tips: '若商品属于违禁品或禁止贩售至海外的商品均有可能无法通关。我们将取消此类商品的订单。敬请见谅。 ',
  },
  amazon: {
    product_detail: '亚马逊商品',
  },
  information: {
    information: '资讯',
    news: '最新消息',
    terms_and_conditions: '条款及条件',
    privacy_policy: '私隐政策',
    about_us: '联络我们',
  },
  facebook_pannel: {
    homepage: 'facebook主页',
    line1: '讚好我们的facebook账号',
    line2: '您可以在这里了解到Okubuy的最新消息',
  },
  transportation: {
    parcel_list: '邮包列表',
    warehouses: '仓库地址',
    parcel_information: '请输入网站发货的货仓地址、快递公司、追踪号码、货件资料去确认货件',
    parcel_screen: '邮包筛选',
    goods_name: '货品名',
    Valuation_fee: '保价费用(HKD)',
    parcel_describe: '邮包内含物描述',
    parcel_status: '邮包状态',
    track_num: '追踪号码',
    ware: '货仓',
    weight_pounds: '重量(磅)',
    courier_tracknum: '快递公司 / 追踪号码',
    new_status: '最新状态',
    product_details: '货品详情 / 货值',
    push_parcel: '主动推送邮包',
    cancel_record: '取消记录',
    completion_information: '补全信息',
    addgoods: '添加商品',
    send_out: '送出',
    placeholder: {
      choose: '请选择',
      warehouse_courier: '选择仓库地址及快递公司',
      status: '请选择状态',
      warehouses: '请选择仓库',
      tracking_num: '请输入追踪号码',
    },
    label: {
      warehouse_courier: '仓库地址及快递公司',
      tracking_num: '追踪号码',
      unit: '单位'
    },
  },
  pickup_point_selector: {
    pickups: '自提点',
    post_office: '邮政局',
	post_locker: '智邮站',
	ok: 'OK便利店',
	cainiao_locker: '菜鸟智能柜',
    address: '地址',
  },
  validate: {
    mobile: '请输入正确的电话号码',
    fixline: '请输入正确的电话号码',
  },
  remove: {
    a: '初级会员',
    b: '初级推广员',
  },
  payment: {
    paypal: 'PayPal',
    alipay: '支付宝',
    wechatpay: '微信支付',
    go_to_alipay_website_for_payment: '前往支付宝网站付款',
    use_alipay_app_scan: '使用支付宝APP"扫一扫"付款',
    use_fps_scan: '扫码付款',
    use_wechat_app_scan: '使用微信"扫一扫"付款',
    pay_with_alipay: '支付宝付款',
    payment_error: '支付遇到错误，请联系客服。 ',
    has_the_payment_been_completed: '已完成支付？ ',
    pay: '付款',
    checkout_counter: '收银台',
    sub_order1: '请您在提交订单后',
    sub_order2: '内完成支付，否则订单会自动取消',

    order_timeout: '订单付款时间已超时',
    order_not_pay: '该订单目前不能支付',
    order_paid_successful: '支付成功',
    go_to_alipay_app_for_payment: '打开支付宝支付',
    no_orders: '没有订单',

  },
  comment: {
    order_evaluation: '订单评价',
    order_number: '订单编号',
    product_rating: '商品评分',
    product_review: '商品评价',
    commodity_order: '商品晒单',
  },
  state: {
    choose_your_country_or_region: '选择你的国家或地区',
    africa_middle_east_and_india: '非洲、中东和印度',
    asia_pacific: '亚太地区',
    europe: '欧洲',
    latin_america_and_the_caribbean: '拉丁美洲和加勒比地区',
    the_united_states_canada_and_puerto_rico: '美国，加拿大和波多黎各',
  },
  tracking_statuses: {
    1: '新建订单',
    2: '已到达自取点',
    3: '已发SMS通知客人取货',
    4: '客人已经取货',
    10: '预报',
    11: '揽收',
    12: '运输中',
    13: '派件中',
    14: '已签收',
    15: '投递失败',
    16: '其他',
    17: '收件',
    18: '到件',
    19: '客人签收',
    20: '问题件',
  },
  ...el,
}
